export default __webpack_public_path__ + "static/react-ecea24c3e13f37dd5e94701bdcc03aa2.png";